/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { Action } from '@ngrx/store';
import { type } from '../../../shared/utility/utilityHelpers';

export const ActionTypes = {

    GET_COMMISSION_LIST_ACTION: type('[Commissions] Get Commissions List'),
    GET_COMMISSION_SUCCESS: type('[Commissions] Get Commissions List success'),
    GET_COMMISSION_FAIL: type('[Commissions] Get Commissions List Fail'),

    GET_COMMISSION_LIST_COUNT_ACTION: type('[Commissions] Get Commissions List Count Action'),
    GET_COMMISSION_LIST_COUNT_SUCCESS: type('[Commissions] Get Commissions List Count success'),
    GET_COMMISSION_LIST_COUNT_FAIL: type('[Commissions] Get Commissions List Count Fail'),
};

export class GetCommissionListAction implements Action {
  type = ActionTypes.GET_COMMISSION_LIST_ACTION;
  constructor(public payload: any) {}
}
  
export class GetCommissionListSuccessAction implements Action {
  type = ActionTypes.GET_COMMISSION_SUCCESS;
  constructor(public payload: any) {}
}
  
export class GetCommissionListFailAction implements Action {
  type = ActionTypes.GET_COMMISSION_FAIL;
  constructor(public payload: any = null) {}
}

export class GetCommissionListCountAction implements Action {
  type = ActionTypes.GET_COMMISSION_LIST_COUNT_ACTION;
  constructor(public payload: any) {}
}

export class GetCommissionListCountSuccessAction implements Action {
  type = ActionTypes.GET_COMMISSION_LIST_COUNT_SUCCESS;
  constructor(public payload: any) {}
}

export class GetCommissionListCountFailAction implements Action {
  type = ActionTypes.GET_COMMISSION_LIST_COUNT_FAIL;
  constructor(public payload: any = null) {}
}

export type Actions = 
  | GetCommissionListAction 
  | GetCommissionListSuccessAction 
  | GetCommissionListFailAction
  | GetCommissionListCountAction
  | GetCommissionListCountSuccessAction
  | GetCommissionListCountFailAction;